import type { EventSalesAggregated as GQLItem } from '../../../generated/api.graphql';
import { calculatePercentage } from '../../../util/percentageUtils';
import * as EventSales from './EventSales';

/** The wrapper the `aggregatedEventSales` query returns; `salesData` is the shared `EventSales`. */
export type EventSalesAggregated = {
  salesData: EventSales.EventSales;
};

export const getNew = (): EventSalesAggregated => ({ salesData: EventSales.getNew() });

export const fromGql = (item: GQLItem): EventSalesAggregated => ({
  salesData: EventSales.fromGql(item.salesData),
});

export const getSalesPercentage = (aggregatedSales: EventSalesAggregated) => {
  const { totalSales, totalSalesLimit } = aggregatedSales.salesData;
  return calculatePercentage(totalSales, totalSalesLimit);
};

export const getTicketsPercentage = (aggregatedSales: EventSalesAggregated) => {
  const { ticketsSold, totalTickets } = aggregatedSales.salesData;
  return calculatePercentage(ticketsSold, totalTickets);
};
